import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Checkboxes } from '@typings';

import { CheckboxRow } from './CheckboxRow';

interface Props {
  options: Checkboxes.Option[];
  value?: string;
  optionsState: Checkboxes.OptionsState;
  onChange: (clickedValue: string) => void;
  collapseLevel?: number;
}

export const CheckboxGroup = ({ options, value, onChange, optionsState, collapseLevel }: Props) => {
  const nestedOptions =
    isDefined(value) ?
      options.filter(nestedOption => nestedOption.parentValue === value)
    : options.filter(option => !isDefined(option.parentValue));

  if (isEmpty(nestedOptions)) {
    return null;
  }

  return (
    <ul
      className={cn('checkbox-group group -m-2 list-none p-2 group-[.checkbox-group]:ml-5', {
        'overflow-hidden': isDefined(collapseLevel) && collapseLevel >= 0,
      })}
    >
      {nestedOptions.map((nestedOption, index) => {
        const optionState = optionsState[nestedOption.value];
        const isInitiallyExpanded = optionState === 'checked' || optionState === 'indeterminate';

        return (
          <CheckboxRow
            key={`${nestedOption.value}-parent-${index}`}
            nestedOption={nestedOption}
            options={options}
            optionState={optionState}
            onChange={onChange}
            collapseLevel={collapseLevel}
            optionsState={optionsState}
            isInitiallyExpanded={isInitiallyExpanded}
          />
        );
      })}
    </ul>
  );
};
